<template>
  <div :class="{'is-loading':ui.loading}">
    <get-link-component
      :company-preference-center-url-sign-in="companyPreferenceCenterUrlSignIn"
      :company-preference-center-url-form="companyPreferenceCenterUrlForm"
    />
    <set-company-details-component
      :company-data="companyData"
      :edit-company-details-url="editCompanyDetailsUrl"
    />
    <set-sections-component :sections-data="local.sectionsData" />
    <set-fields-component
      :subscribed-fields-data="local.subscribedFieldsData"
      :auto-complete-get-available-fields-url="autoCompleteGetAvailableFieldsUrl"
      @subscribedFieldsUpdated="subscribedFieldsUpdatedEventHandler($event)"
    />
    <div
      v-if="isDirty"
      class="Section"
    >
      <div class="Buttons Buttons--small">
        <a
          class="Button Button--secondary left"
          href="#"
          @click.prevent="reset"
        >
          <span class="icon-reset" /> Reset
        </a>
        <a
          class="Button Button--green right"
          href="#"
          @click.prevent="save"
        >
          <span class="icon-save" /> Save
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import GetCompanyPreferenceCenterLink from './elements/get-link.vue';
import SetCompanyDetailsForPreferenceCenter from './elements/company-details.vue';
import SetSectionsForPreferenceCenter from './elements/subscribed-sections.vue';
import SetFieldsForPreferenceCenter from './elements/subscribed-fields.vue';
import CommonOperations from '../../mixins/common-operations';
import LocalCopy from '../../lang/en.json';

export default {
  components: {
    'get-link-component': GetCompanyPreferenceCenterLink,
    'set-company-details-component': SetCompanyDetailsForPreferenceCenter,
    'set-sections-component': SetSectionsForPreferenceCenter,
    'set-fields-component': SetFieldsForPreferenceCenter,
  },
  mixins: [CommonOperations],
  props: {
    subscribedFieldsData: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    autoCompleteGetAvailableFieldsUrl: {
      type: String,
      required: true,
      default: '',
    },
    updateUrl: {
      type: String,
      required: true,
      default: '',
    },
    sectionsData: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    companyData: {
      type: Object,
      required: true,
      default() {
        return null;
      },
    },
    editCompanyDetailsUrl: {
      type: String,
      required: true,
      default: '',
    },
    companyPreferenceCenterUrlSignIn: {
      type: String,
      required: true,
      default: '',
    },
    companyPreferenceCenterUrlForm: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      ui: {
        loading: false,
      },
      local: {
        subscribedFieldsData: null,
        sectionsData: null,
      },
      copy: {
        subscribedFieldsData: null,
        sectionsData: null,
      },
    };
  },
  computed: {
    isDirty() {
      return this.$_commonOperations_jsonNotEqual(this.local.subscribedFieldsData, JSON.parse(this.copy.subscribedFieldsData))
          || this.$_commonOperations_jsonNotEqual(this.local.sectionsData, JSON.parse(this.copy.sectionsData));
    },
  },
  created() {
    this.formatData();
    this.copyData();
  },
  methods: {
    save() {
      this.ui.loading = true;
      this.$_commonOperations_putData(this.updateUrl, {
        obj: { fields: this.local.subscribedFieldsData, sections: this.local.sectionsData },
      }).then((response) => {
        this.ui.loading = false;
        this.$_commonOperations_emitMessage(response.data.message, 'info');
        this.$bus.$emit('updateDataAfterSave', {
          subscribedFieldsData: this.local.subscribedFieldsData,
        });
        this.copyData();
      })
        .catch((response) => {
          this.ui.loading = false;
          this.$_commonOperations_emitMessage(response.data.message, 'error');
        });
    },
    reset() {
      this.resetData();
      // TODO - could we pass the data down to the children via props and react to any changes by watching the props?
      this.$bus.$emit('updateDataAfterReset', {
        subscribedFieldsData: this.local.subscribedFieldsData,
        sectionsData: this.local.sectionsData,
      });
      this.$_commonOperations_emitMessage(LocalCopy.studentPreferenceCenter.reset.success, 'info');
    },
    subscribedFieldsUpdatedEventHandler(eventData) {
      this.local.subscribedFieldsData = eventData;
    },
    copyData() {
      this.copy.subscribedFieldsData = JSON.stringify(this.local.subscribedFieldsData);
      this.copy.sectionsData = JSON.stringify(this.local.sectionsData);
    },
    resetData() {
      this.local.subscribedFieldsData = JSON.parse(this.copy.subscribedFieldsData);
      this.local.sectionsData = JSON.parse(this.copy.sectionsData);
    },
    formatData() {
      this.local.subscribedFieldsData = this.subscribedFieldsData;
      this.local.sectionsData = this.sectionsData;
    },
  },
};
</script>
